import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 17v-10l7 10v-10","key":"svg-0"}],["path",{"d":"M15 17h5","key":"svg-1"}],["path",{"d":"M15 10a2.5 3 0 1 0 5 0a2.5 3 0 1 0 -5 0","key":"svg-2"}]]

/**
 * IconNumber
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE3di0xMGw3IDEwdi0xMCIgLz4KICA8cGF0aCBkPSJNMTUgMTdoNSIgLz4KICA8cGF0aCBkPSJNMTUgMTBhMi41IDMgMCAxIDAgNSAwYTIuNSAzIDAgMSAwIC01IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber = createReactComponent('outline', 'number', 'Number', __iconNode);

export default IconNumber;